export const name = "SEC";
export const summary = `Computes the secant of \`X\`.`;
export const reference = `
## SEC

Computes the secant of \`X\`.

\`\`\`
SEC(X)
\`\`\`

### Description

Computes the secant for the angle of \`X\`, where \`X\` is specified in radians.\`X\` can be any data type that coerces to \`FLOAT64\`.

| X | SEC(X) |
| --- | --- |
| \`+inf\` | \`NaN\` |
| \`-inf\` | \`NaN\` |
| \`NaN\` | \`NaN\` |
| \`NULL\` | \`NULL\` |


### Return Data Type

\`FLOAT64\`


### Example



\`\`\`
SELECT SEC(100) AS a, SEC(-1) AS b;

/*----------------+---------------*
 | a | b |
 +----------------+---------------+
 | 1.159663822905 | 1.85081571768 |
 *----------------+---------------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/mathematical_functions
`;
